// Line Entry — the `on_header_change: offer` banner (canvas boards 1 and 10):
// the user just picked the source document in the header, and the line form
// says how many lines it holds and offers what it can do with them — the
// first offer as the primary action, "Not now" to dismiss.

import { FileText } from 'lucide-react'
import { INFO_BAND, btn, btnPri } from './styles'

interface Props {
  document: string
  /** Lines the document still offers; null while counting. */
  count: number | null
  /** What the lines are called ("PO lines"). */
  noun: string
  commands: Array<{ name: string; label: string }>
  busy: string | null
  onRun: (command: string) => void
  onDismiss: () => void
}

export default function LineEntryBanner({ document, count, noun, commands, busy, onRun, onDismiss }: Props) {
  if (!commands.length) return null
  const empty = count === 0
  return (
    <div role="status" style={{
      background: INFO_BAND.bg, border: `1px solid ${INFO_BAND.border}`, color: INFO_BAND.fg,
      borderRadius: 10, padding: '10px 14px', margin: '8px 0', display: 'flex', alignItems: 'center',
      gap: 10, flexWrap: 'wrap', fontSize: 14,
    }}>
      <FileText size={18} aria-hidden="true" />
      <span style={{ flex: 1, minWidth: 240 }}>
        {count == null ? (
          <><b>{document}</b> — how do you want to bring its {noun.toLowerCase()} in?</>
        ) : empty ? (
          <><b>{document} has no {noun.toLowerCase()} left to add.</b></>
        ) : (
          <><b>{document} has {count.toLocaleString()} {noun.toLowerCase()} to add.</b> How do you want to bring them in?</>
        )}
      </span>
      {!empty && commands.map((c, i) => (
        <button key={c.name} type="button" disabled={!!busy} onClick={() => onRun(c.name)}
          style={{ ...(i === 0 ? btnPri : btn), cursor: busy ? 'not-allowed' : 'pointer' }}>
          {c.label}
        </button>
      ))}
      <button type="button" onClick={onDismiss}
        style={{ ...btn, background: 'transparent', borderColor: 'transparent', color: INFO_BAND.fg }}>
        Not now
      </button>
    </div>
  )
}
